import React, { FC } from "react";
import { IconButton, IconButtonProps } from "@xapp/components";

interface LoadingIconButtonProps extends Omit<IconButtonProps, 'loading'> {
    isLoading: boolean;
}

/**
 * @deprecated Use LoadingButton, which also accepts an icon.
 */
const LoadingIconButton: FC<LoadingIconButtonProps> = (props: LoadingIconButtonProps) => {
    const { isLoading, ...buttonProps } = props;
    return <IconButton loading={isLoading} {...buttonProps} />;
};

export { LoadingIconButton, LoadingIconButtonProps };
